import React from 'react';
import { formatAuditTimestamp, formatAuditTimestampExact } from '../utils/formatAuditTimestamp';
import type { AuditTimestampProps } from './AuditTimestamp.types';

/**
 * Muestra un timestamp de auditoría con fecha y hora de 12 h: "17/09/2026 10:50:45 AM".
 * El hover añade las centésimas vía atributo `title`, para desempatar dos entradas del
 * mismo segundo sin ensuciar la lectura.
 */
export const AuditTimestamp: React.FC<AuditTimestampProps> = ({ timestamp, size = 'sm', className = '' }) => {
  // Tokens del sistema en vez de `slate-500`, que era el único color crudo de todo el panel de
  // auditoría: el resto ya iba por `content-*` y por eso la fecha desentonaba en oscuro.
  const classes = [
    size === 'xs' ? 'text-xs' : 'text-sm',
    'text-content-secondary dark:text-dark-content-secondary tabular-nums',
    className,
  ]
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  return (
    <time dateTime={timestamp} title={formatAuditTimestampExact(timestamp)} className={classes}>
      {formatAuditTimestamp(timestamp)}
    </time>
  );
};

AuditTimestamp.displayName = 'AuditTimestamp';
